export default function GroupBadge({
  groupName,
  bgColor,
}: {
  groupName: string | undefined;
  /** 없으면 기본 `bg-sig` */
  bgColor?: string;
}) {
  if (!groupName) return null;
  return (
    <div
      className={`flex min-w-0 max-w-[120px] items-center rounded-sm p-1 text-white ${bgColor ? "" : "bg-sig"}`}
      style={bgColor ? { backgroundColor: bgColor } : undefined}
    >
      <span className="min-w-0 truncate px-1 text-sm font-semibold">
        {groupName}
      </span>
    </div>
  );
}
